import styled from "styled-components"

const StyledCircle = styled.section`
  padding: 144px 0;
  .circle-container {
    max-width: 726px;
    margin: 0 auto;
    padding: 0 30px;
    .circle-header {
      max-width: 666px;
      margin: 0 auto 116px;
      text-align: center;
      .title {
        margin: 20px 0 29px;
      }
    }
  }
  .circle-animation {
    &__container {
      position: relative;
      max-width: 1210px;
      width: 100%;
      margin: 0 auto;
      padding: 0 30px;
    }
    &__progress {
      position: absolute;
      top: 50%;
      left: 0;
      width: 61px;
      height: 61px;
      border-radius: 50%;
      transform: translateY(-46%);
      border: 1px solid #000;
      .rotator {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50%;
        z-index: 2;
        transition: 1s;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 50%;
          border-radius: 50%;
          width: 21px;
          height: 21px;
          transform: translate(-50%, -50%);
          border: 1px solid #000;
        }
      }
      .step {
        padding: 0;
        position: absolute;
        border-radius: 50%;
        width: 21px;
        height: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 3;
        transition: 0.2s;
        border: none;
        &.bg {
          background-color: #fff;
          z-index: 1;
        }
        span {
          font-size: 12px;
          line-height: 16px;
        }
        &.top {
          top: 0;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        &.right {
          top: 50%;
          right: 0;
          transform: translate(50%, -50%);
        }
        &.bottom {
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 50%);
        }
        &.left {
          top: 50%;
          left: 0;
          transform: translate(-50%, -50%);
        }
        &:hover {
          background-color: #00fb6e;
        }
      }
    }
    &__holder {
      position: relative;
      margin: 0 auto;
      width: 700px;
      height: 570px;
      background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjMuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MTEgNTc4LjgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDcxMSA1NzguODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiMwMDAwMDA7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0MXtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8ZyBpZD0iR3JvdXBfOTg0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzMyIC00MS41KSI+Cgk8cGF0aCBpZD0iUGF0aF80MzFfMl8iIGNsYXNzPSJzdDAiIGQ9Ik0zNTEuNSwzMzYuM2gxLjVjMjMuMSwwLDQyLjgsMTYuOSw0Ni40LDM5LjdDNDIxLDUxMy44LDU0MC4zLDYxOS4zLDY4NC4yLDYxOS4zCgkJUzk0Ny40LDUxMy44LDk2OS4xLDM3NmMzLjYtMjIuOCwyMy4yLTM5LjcsNDYuNC0zOS43aDIuNyIvPgoJPHBhdGggaWQ9IlBhdGhfNDMyXzJfIiBjbGFzcz0ic3QwIiBkPSJNMTAxNC45LDMyNS41TDEwMTQuOSwzMjUuNWMtMjMuMSwwLTQyLjgtMTYuOS00Ni40LTM5LjdDOTQ2LjksMTQ3LjksODI3LjYsNDIuNSw2ODMuNyw0Mi41CgkJUzQyMC41LDE0Ny45LDM5OC45LDI4NS43Yy0zLjYsMjIuOC0yMy4yLDM5LjctNDYuNCwzOS43SDM1MWgtMi43Ii8+Cgk8cmVjdCBpZD0iUmVjdGFuZ2xlXzE4MCIgeD0iOTQzIiB5PSIyODEiIGNsYXNzPSJzdDEiIHdpZHRoPSIxMDAiIGhlaWdodD0iNDkiLz4KCTxyZWN0IGlkPSJSZWN0YW5nbGVfMTgxIiB4PSIzMzIiIHk9IjMzMCIgY2xhc3M9InN0MSIgd2lkdGg9IjEwMCIgaGVpZ2h0PSI0OSIvPgo8L2c+Cjwvc3ZnPgo=");
      .circle-arrow {
        background: none;
        padding: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        border: 2px solid #000000;
        z-index: 2;
        transition: 0.2s;
        [stroke] {
          transition: 0.2s;
        }
        &:hover {
          border-color: #00fb6e;
          [stroke] {
            stroke: #00fb6e;
          }
        }
        &.prev {
          left: -4.5px;
          transform: translateY(-27.5px);
        }
        &.next {
          transform: translateY(-17px);
          right: 3px;
        }
      }
    }
    &__logotype {
      text-align: center;
      padding: 57px 0 48px;
    }
    &__slider {
      .slick-slide {
        opacity: 0;
      }
      .slick-slide.slick-active {
        z-index: 3;
        animation-name: silde-down;
        animation-duration: 1s;
      }
      .slider-box {
        text-align: center;
        .step-name {
          font-size: 24px;
          line-height: 31px;
          margin-bottom: 15px;
        }
        .step-image {
          min-height: 102px;
        }
        .step-title {
          margin-bottom: 23px;
          p {
            font-size: 24px;
            line-height: 32px;
            font-weight: 600;
          }
          a {
            text-decoration: underline;
            transition: 0.2s;
            &:hover {
              color: #00fb6e;
            }
          }
        }
        .box-udo {
          margin: 70px auto 30px;
          max-width: 400px;
          border-radius: 41px;
          position: relative;
          border: 2px solid #000000;
          .icon {
            padding: 0 30px;
            position: absolute;
            width: 100%;
            max-width: 282px;
            bottom: 100%;
            left: 50%;
            transform: translate(-50%, 15px);
            background: #fff;
            svg {
              width: 100%;
            }
          }
          .text {
            padding: 33px 20px 23px;
            span {
              font-size: 16px;
              line-height: 21px;
              padding: 0 10px;
              text-transform: uppercase;
            }
          }
        }
        .step-buttons {
          max-width: 480px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          .box-button {
            flex-basis: 226px;
            max-width: 226px;
            .text-info {
              font-size: 24px;
              line-height: 31px;
              margin-bottom: 15px;
              letter-spacing: 1.4px;
              &.sm {
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 5px;
                letter-spacing: 0;
              }
            }
            a {
              min-width: 224px;
              background-color: #fff;
            }
          }
        }
        &.first {
          .step-title {
            max-width: 410px;
            margin: 0 auto 23px;
          }
        }
        &.second {
          .step-title {
            max-width: 510px;
            margin: 0 auto 23px;
          }
        }
        &.third {
          .step-name {
            margin: 0;
          }
          .step-title {
            max-width: 382px;
            margin: 0 auto;
          }
        }
        &.fourth {
          .step-title {
            max-width: 536px;
            margin: 0 auto 13px;
          }
          .step-buttons {
            .box-button {
              .text-info {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    padding: 140px 0 150px;
    .circle-animation {
      &__container {
        max-width: 1060px;
      }
    }
  }
  @media screen and (max-width: 1200px) {
    .circle-animation {
      &__progress {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
        top: initial;
        bottom: -80px;
        left: 50%;
        width: 86px;
        height: initial;
        border-radius: 0;
        transform: translate(-50%, -50%);
        border: none;
        .rotator,
        .step.bg {
          display: none;
        }
        .step {
          position: static;
          width: 11px;
          height: 11px;
          border-radius: 50%;
          border: 1px solid #000;
          transition: 0.3s;
          transform: none !important;
          span {
            font-size: 0;
            line-height: 0;
          }
          &.active {
            background-color: #000;
          }
        }
      }
    }
  }
  @media screen and (max-width: 800px) {
    padding: 100px 0;
    .circle-container {
      .circle-header {
        margin-bottom: 60px;
      }
    }
    .circle-animation {
      &__progress {
        bottom: -30px;
      }
      &__container {
        max-width: 100%;
        padding: 0;
      }
      &__holder {
        width: 550px;
        height: 550px;
        background-size: 550px 550px;
        .circle-arrow {
          &.prev {
            left: -10px;
            transform: translateY(-27px);
          }
          &.next {
            transform: translateY(-18px);
            right: -7px;
          }
        }
      }
      &__logotype {
        text-align: center;
        padding: 70px 0 20px;
        svg {
          max-width: 120px;
        }
      }
      &__slider {
        .slider-box {
          .step-name {
            font-size: 16px;
            line-height: 21px;
            margin-bottom: 15px;
          }
          .step-image {
            min-height: 102px;
          }
          .step-title {
            margin-bottom: 20px;
            p {
              font-size: 16px;
              line-height: 24px;
            }
          }
          .box-udo {
            margin: 70px auto 30px;
            position: relative;
            border: 2px solid #000000;
            .icon {
              max-width: 240px;
            }
            .text {
              padding: 25px 20px 20px;
            }
          }
          .step-buttons {
            max-width: 440px;
            .box-button {
              flex-basis: 200px;
              max-width: 200px;
              .text-info {
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 10px;
                text-transform: uppercase;
                &.sm {
                  display: none;
                }
              }
              a {
                min-width: 200px;
              }
            }
          }
          &.first {
            .step-title {
              max-width: 216px;
            }
          }
          &.second {
            .step-title {
              max-width: 316px;
            }
          }
          &.third {
            .step-title {
              max-width: 316px;
            }
          }
          &.fourth {
            .step-title {
              max-width: 316px;
              margin-bottom: 23px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    padding: 70px 0 120px;
    overflow: hidden;
    .circle-container {
      max-width: 100%;
      padding: 0 16px;
      .circle-header {
        max-width: 100%;
        margin: 0 auto 75px;
        .title {
          margin: 20px 0;
          font-size: 34px;
          line-height: 43px;
        }
      }
    }
    .circle-animation {
      &__progress {
        bottom: -67px;
      }
      &__holder {
        width: 400px;
        height: 400px;
        background: none;
        border: 1px solid #000;
        border-radius: 50%;
        .circle-arrow {
          width: 40px;
          height: 40px;
          &.prev {
            left: 30px;
            transform: translateY(-20px);
          }
          &.next {
            transform: translateY(-20px);
            right: 30px;
          }
        }
      }
      &__logotype {
        text-align: center;
        padding: 22px 0 12px;
      }
      &__slider {
        .slick-slide {
          opacity: 1;
          animation-name: fade-out;
          animation-fill-mode: forwards;
          animation-duration: 0.4s;
          &.slick-active {
            animation: none;
          }
        }
        .slider-box {
          .step-name {
            font-size: 16px;
            line-height: 21px;
            margin-bottom: 5px;
          }
          .step-image {
            min-height: 88px;
            svg {
              max-width: 50px;
            }
          }
          .step-title {
            margin-bottom: 20px;
            p {
              font-size: 16px;
              line-height: 24px;
            }
          }
          .box-udo {
            margin: 35px auto 30px;
            max-width: 202px;
            border-radius: 13px;
            .icon {
              padding: 0 13px;
              max-width: 131px;
            }
            .text {
              padding: 15px 0px 10px;
              span {
                font-size: 9px;
                line-height: 12px;
                padding: 0 7px;
              }
            }
          }
          .step-buttons {
            max-width: 340px;
            .box-button {
              flex-basis: 160px;
              max-width: 160px;
              a {
                min-width: 160px;
                padding: 14px 2px;
              }
            }
          }
          &.first {
            .step-title {
              max-width: 216px;
              margin-bottom: 10px;
            }
          }
          &.second {
            .step-title {
              max-width: 216px;
              margin-bottom: 10px;
            }
          }
          &.third {
            .step-title {
              max-width: 216px;
            }
          }
          &.fourth {
            .step-title {
              max-width: 216px;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 420px) {
    .circle-animation {
      &__progress {
        bottom: -67px;
      }
      &__holder {
        margin-left: calc((400px - 100vw) / -2);
        padding: 0 30px;
        .circle-arrow {
          width: 30px;
          height: 30px;
          svg {
            max-width: 6px;
          }
          &.prev {
            left: 30px;
          }
          &.next {
            right: 30px;
          }
        }
      }
      &__logotype {
        text-align: center;
        padding: 15px 0 20px;
      }
      &__slider {
        .slider-box {
          .step-name {
            font-size: 16px;
            line-height: 21px;
            margin-bottom: 20px;
          }
          .step-image {
            min-height: 45px;
            svg {
              max-width: 50px;
              height: auto;
            }
          }
          .step-title {
            margin-bottom: 10px;
            p {
              line-height: 20px;
            }
          }
          .box-udo {
            max-width: 230px;
            margin: 40px auto 35px;
            .icon {
              max-width: 150px;
            }
            .text {
              padding: 20px 0;
              span {
                font-size: 12px;
                line-height: 15px;
              }
            }
          }
          .step-buttons {
            max-width: 100%;
            .box-button {
              flex-basis: calc(50% - 15px);
              max-width: calc(50% - 15px);
              a {
                min-width: 100%;
                span {
                  white-space: nowrap;
                }
              }
            }
          }
          &.first {
            .step-title {
              max-width: 180px;
              margin: 20px auto 30px;
            }
          }
          &.second {
            .step-title {
              max-width: 250px;
              margin: 20px auto 25px;
            }
          }
          &.fourth {
            .step-title {
              max-width: 250px;
              margin: 20px auto 30px;
            }
          }
        }
      }
    }
  }
  @keyframes silde-down {
    0% {
      transform: translateY(-100px);
    }
    100% {
      transform: translateY(0);
    }
  }
  @keyframes fade-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`

export default StyledCircle
